<script setup lang="ts">
import { Button } from '@/components/ui/button';
import HumanActivityList from '@/components/activity/HumanActivityList.vue';
import SectionSurface from '@/components/workspace/SectionSurface.vue';
import { ChevronRight, Workflow } from 'lucide-vue-next';
import type { ClientOverviewActivityItem } from './types';

interface Props {
    items: ClientOverviewActivityItem[];
}

defineProps<Props>();

const emit = defineEmits<{
    (e: 'open-activity'): void,
}>();
</script>

<template>
    <SectionSurface title="Recent activity" description="The latest changes across this client workspace." :icon="Workflow" density="compact" presentation="editorial">
        <template #actions>
            <Button variant="ghost" size="sm" class="rounded-full px-0" @click="emit('open-activity')">
                View full timeline
                <ChevronRight class="ml-2 size-4" />
            </Button>
        </template>

        <HumanActivityList :items="items" empty-text="No recent client activity yet." :limit="3" />
    </SectionSurface>
</template>
